"use client"
/* */
const dynamic = (getDynamicProp) => ({
  __dynamicProp: getDynamicProp
});

export { dynamic as default, dynamic };
//# sourceMappingURL=dynamic.mjs.map
